{
  "ChangeLang_Title": "Changer de langue",
  "ChangeLang_Subtitle": "Sélectionnez la langue dans laquelle vous souhaitez afficher le contenu de la page Web dans votre session Web actuelle sur cet ordinateur.",
  "ChangeLang_Field_Label": "Langue",
  "ChangeLang_Remember_Label": "Se souvenir de ma sélection",
  "ChangeLang_Buttons_Apply": "Appliquer",
  "ChangeLang_Buttons_Cancel": "Annuler",
  "NAME": "ChangeLangLanguage"
}